export const PHCOnboardingConstants = {
  PHC_RESET_ONBOARDING_DATA: "PHC_RESET_ONBOARDING_DATA",
  PHC_UPDATE_ONBOARDING_DATA: "PHC_UPDATE_ONBOARDING_DATA",

  // onboarding Data
  PHC_ONBOARDING_DATA_API: "phc/portfolio/details",
  PHC_ONBOARDING_DATA_SAGA: "PHC_ONBOARDING_DATA_SAGA",
  PHC_ONBOARDING_DATA_REQUEST: "PHC_ONBOARDING_DATA_REQUEST",
  PHC_ONBOARDING_DATA_RESPONSE: "PHC_ONBOARDING_DATA_RESPONSE",

  //STAGE 1
  PHC_UPLOAD: "phc/portfolio/upload",
  PHC_DOWNLOAD_EXCEL: "phc/portfolio/excel",

  //STAGE 2
  LISTING_UPLOAD_PORTFOLIO: "phc/portfolio/fetch",
  GET_COMPANY_LIST: "phc/portfolio/get-company-list",
  PHC_UPLOADED_UPDATE: "phc/portfolio/update",
  PHC_ONBOARD_PREVIEW: "phc/portfolio/onboard-preview",
  PHC_PREVIEWSTOCK_DELETE: "phc/portfolio/delete",
  PHC_GENERATE: "phc/health-check/generate",

  //STAGE 3
  PHC_PORTFOLIO_GRAPH_DETAILS: "phc/health-check/portfolio-details", //graphData
  PHC_PRLP: "phc/health-check/portfolio-profiling",
  PHC_PERFORMANCE_CHART: "phc/health-check/performance-chart",
  PHC_SJS: "phc/health-check/portfolio-stock-allocation-and-analytics",
  PHC_PORTFOLIO_HIGHLIGHTS: "phc/health-check/portfolio_highlights",
  PHC_SECTOR_DIVERSIFICATION: "phc/health-check/sector_diversification",
  PHC_LIQUIDITY_ANALYSIS: "phc/health-check/liquidity_analysis",
  PHC_PERFORMANCE_ANALYTICS: "phc/health-check/performance_analytics",
  PHC_RECOMMEND_PRODUCT: "phc/health-check/recommend-product",
  PHC_PORTFOLIO_REVIEW: "phc/health-check/portfolio-review",
  PHC_AI_RECOMMEND: "phc/health-check/ai-recommend",
  PHC_REGENERATE: "phc/health-check/regenerate",

  PHC_SAVE_REPORT: "phc/portfolio/save-report", //save report

  PHC_INITIATE_DOCUMENT_SIGNING_API: `/phc/portfolio/initiate-signing`,

  // PHC-Navia
  ONE_MONEY_REDIRECT_URL_API: "/onemoney/redirectional-url",
  PHC_GET_CONSENT_ID_API: "/onemoney/consent-status",

  // PHC-redirect to ckyc 
  PHC_CKYC_REDIRECT_API: "/phc/health-check/update-phc-stage",

};
